<template>
  <div>
    <b-modal ref="my-modal" size="md" centered hide-footer title="Export Delivery Report">
      <form class="mt-4">
        <b-row class="mt-2">
          <b-col md="12">
            <div>
              <label class="labels">Customer</label>
                <v-select
                  id="mySelect"
                  label="text"
                  v-model="model.customer"
                  :options="customerList"
                  :reduce="(text) => text.value"
                  class="style-chooser"
                  placeholder="search customer..."
                  style="margin: 0 auto;"
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!model.customer"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
            </div>
                <div>
                  <label class="labels mt-3">Select month (Export Monthly)</label>
                  <vue-monthly-picker
                    :inputClass="{ input: isDisplayInput }"
                    :monthLabels="locale"
                    :min="min"
                    :max="max"
                    @selected="handleSelect"
                    :selectedBackgroundColor="selectedBackgroundColor"
                    v-model="model.selectedMonth"
                  >
                  </vue-monthly-picker>
                </div>
          </b-col>
        </b-row>
        <b-row class="ml-2 mt-4">
          <b-button class="mb-3" v-b-tooltip.hover.top @click="doExportExcelMonthly" title="Export to Excel (Monthly)" variant="primary" type="submit"
            ><font-awesome-icon icon="download"></font-awesome-icon
          >Download</b-button>
        </b-row>
        <b-button class="mt-5 btn btn-outline-danger" variant="outline" @click="hideModal"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
      </form>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
export default {
  components: { VueMonthlyPicker},
  data() {
    return {
      addDate: new Date(),
      disabled: false,
      min: null,
      max: null,
      apiUrl: {
        exportExcelMonthly: window.AppConfig.apiUrl + 'export-receipt-excel-monthly',
      },
      selectedBackgroundColor: '#89CFF0',
      isLimitRange: false,
      isDisplayInput: true,
      model: {
        selectedMonth: this.$moment(new Date()).format('MM-YYYY'),
        customer: null
      },
      locale: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      customerList: [],
    };
  },
  computed: {
    rangeDisplay() {
      if (!this.min || !this.max) {
        return 'Disabled';
      }
      return this.min.format('YYYY/MM') + '-' + this.max.format('YYYY/MM');
    },
  },

  watch: {
    isLimitRange(newValue) {
      if (newValue) {
        this.setSelectRange(moment().subtract(6, 'months'), moment().add(6, 'months'));
      } else {
        this.setSelectRange(null, null);
      }
    },
  },

  methods: {
    // doSubmit() {
    //   alert(this.getDateTime(this.model.selectedMonth));
    // },

    showModal() {
      this.getCustomer()
      this.model.selectedMonth = '';
      this.$validator.reset();
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    handleSelect(value) {
      console.log('Select', value);
    },
    setSelectRange(min, max) {
      this.min = min;
      this.max = max;
    },

     getCustomer() {
      this.$http
        .get(window.AppConfig.apiUrl + 'customer?limit=100')
        .then((response) => {
          this.customerList = [];
          response.data._embedded.customer.forEach((data) => {
            this.customerSales = data.salesType;
            this.customerList.push({
              value: data.uuid,
              text: data.name,
            }),
              (this.currency = data.account.currency);
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },


    /**
     * function to export excell
     * EXPORT EXCEL MONTHLY
     */

    doExportExcelMonthly() {
      let url = this.apiUrl.exportExcelMonthly + '?token=' + this.$store.getters['account/tokens'].access_token;
      if(this.model.customer !== null && this.model.customer !== undefined){
        url += '&customer_uuid=' + this.model.customer
      }
      if ( this.$moment(this.model.selectedMonth).format('MM-YYYY') !== undefined && this.$moment(this.model.selectedMonth).format('MM-YYYY') !== null ) {
        url += '&monthyear=' + this.$moment(this.model.selectedMonth).format('MM-YYYY');
      }
      window.open(url);
    },

   
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM');
      } else {
        return '-';
      }
    },
  },
};
</script>
<style scoped>
</style>